export class JobMatchQueryFilter {
    companyId: any = "";
    userId: any = "";
    candidateId: any = "";
    top5Flag: boolean = true;
    searchText: any = "";
    vendorIds: any = "";
    candidateType: any = [];
    constructor() {}
}